import React, { Component } from "react"
import {
  Container,
} from "reactstrap"

class Academics extends Component {
  render() {
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid>
            <h3>Main Academics</h3>
          </Container>
        </div>
      </React.Fragment>
    )
  }
}

export default Academics;
